import { translate } from "app/filters/i18nFilter";
import type { AICompetitorsSuggestion, SuggestedCompetitors } from "app/pages/activation/types/api";

import { competitorsStepTexts } from "./texts";
import type { CompetitorsMap, CompetitorSchema } from "./types";

export const getCompetitorsMap = (competitors: SuggestedCompetitors[] | CompetitorSchema[]): CompetitorsMap => {
    const map = new Map();

    competitors.forEach((competitor) => {
        if (!map.has(competitor.Domain || competitor.name)) {
            map.set(competitor.Domain || competitor.name, {
                name: competitor.Domain || competitor.name,
                image: competitor.Favicon || competitor.image,
                isAiGenerated: competitor.isAiGenerated || false,
                reason: competitor.reason || translate(competitorsStepTexts.defaultReason),
            });
        }
    });

    return map;
};

export const getUpdatedMap = (newCompetitor: CompetitorSchema, competitorsMap: CompetitorsMap): CompetitorsMap => {
    const isCompetitorInList = competitorsMap.has(newCompetitor.name);

    if (isCompetitorInList) {
        competitorsMap.delete(newCompetitor.name);
        competitorsMap.set(newCompetitor.name, newCompetitor);
        return new Map([[newCompetitor.name, competitorsMap.get(newCompetitor.name)], ...competitorsMap]);
    }

    return new Map([[newCompetitor.name, newCompetitor], ...competitorsMap]);
};

export const getDomainsList = (newData: AICompetitorsSuggestion, previousSelected: CompetitorSchema[]) => {
    const newSuggestion = newData?.competitors?.map((competitor) => competitor.domain) || [];

    return {
        mergedList: [...previousSelected, ...newSuggestion],
        newSuggestion,
    };
};

export const getSelectedCompetitorsNamesList = (selectedCompetitors: CompetitorSchema[]): string[] =>
    selectedCompetitors.map((competitor) => competitor.name);
